import { defineMessages } from 'react-intl';

export const scope = 'app.components.session.sessions_tabs';

export default defineMessages({
  all_sessions: {
    id: `${scope}.all_sessions`,
    defaultMessage: 'All Sessions',
  },
  review_pending: {
    id: `${scope}.review_pending`,
    defaultMessage: 'Review Pending',
  },
  reviewed: {
    id: `${scope}.reviewed`,
    defaultMessage: 'Reviewed',
  },
  session_rating: {
    id: `${scope}.session_rating`,
    defaultMessage: 'Session Rating',
  },
  attendee: {
    id: `${scope}.attendee`,
    defaultMessage: 'Attendee',
  },
  due_date: {
    id: `${scope}.due_date`,
    defaultMessage: 'Due Date',
  },
  exam: {
    id: `${scope}.exam`,
    defaultMessage: 'Exam',
  },
  proctoring_type: {
    id: `${scope}.proctoring_type`,
    defaultMessage: 'Proctoring Type',
  },
  accomodations: {
    id: `${scope}.accomodations`,
    defaultMessage: 'Accomodations',
  },
  tenant: {
    id: `${scope}.tenant`,
    defaultMessage: 'Tenant',
  },
  edit_request: {
    id: `${scope}.edit_request`,
    defaultMessage: 'Edit Request',
  },
});
